import React from 'react';

import {Text, TextProps} from '../../../components/Typography';
import {connectStyles} from './connectStyles';

export const ConnectTitle: React.FC<TextProps> = ({style, ...props}) => (
  <Text style={[connectStyles.title, style]} variant="h2" {...props} />
);
